angular.module('acme.view.application.importExport.importExportJob.directives.importExportJobMappings.modals.change', [])
  .controller('ImportExportJobMappingsModalController', ImportExportJobMappingsModalController);

/**
 * Controller responsible for showing the user the downloadable Outputs for a Export Job Execution
 * @class ImportExportJobMappingsModalController
 * @constructor
 * @return {ImportExportJobMappingsModalController} - Class instance
 */
function ImportExportJobMappingsModalController(
  $uibModalInstance,
  ImportJobsApiService,
  ImportExportsApiService,
  HelpersService,
  JOB_TYPE,
  job,
  mode,
  mappings,
  mapping)
{
  Object.assign(this, {
    $uibModalInstance: $uibModalInstance,
    ImportJobsApiService: ImportJobsApiService,
    ImportExportsApiService: ImportExportsApiService,
    HelpersService: HelpersService,
    JOB_TYPE: JOB_TYPE,
    job: job,
    mode: mode,
    mappings: mappings,
    mapping: mapping
  });

  // TODO: update ui-router to 0.3.0 to avoid calling this manually
  this.$onInit();
}

ImportExportJobMappingsModalController.prototype.$onInit = function() {
  this.vm = this._getVm(this);
  this._loadJobMappingTypes();
};

ImportExportJobMappingsModalController.prototype._getVm = function (initialData) {
  var _data = initialData || {},
    errorMessage = _data.errorMessage || '',
    mapping = Object.assign({}, _data.mapping) || {},
    job = _data.job || {},
    types = _data.types || [];

  return {
    errorMessage: errorMessage,
    mapping: mapping,
    job: job,
    types: types
  };
};

ImportExportJobMappingsModalController.prototype._loadJobMappingTypes = function () {
  var self = this;

  if (self.vm.job.jobType === self.JOB_TYPE.EXPORT) {
    self.ImportExportsApiService.getTypes()
      .then(function (response) {
        self.vm.types = response.data;
      });
  } else {
    this.ImportJobsApiService.getTypes(self.vm.job.id)
      .then(function (response) {
        self.vm.types = response.data;
      });
  }
};

ImportExportJobMappingsModalController.prototype.cancel = function () {
  this.$uibModalInstance.close();
};

ImportExportJobMappingsModalController.prototype.action = function () {
  var viewActions = {
    'view': this.viewAction.bind(this),
    'add': this.addAction.bind(this),
    'edit': this.editAction.bind(this),
    'delete': this.deleteAction.bind(this)
  };

  viewActions[this.mode]();
};

ImportExportJobMappingsModalController.prototype.viewAction = function () {
  this.$uibModalInstance.close();
};

ImportExportJobMappingsModalController.prototype.addAction = function () {
  var self = this;

  // Add
  this.mappings.unshift(this.vm.mapping);

  this.ImportJobsApiService.updateMappings(this.job.id, this.mappings)
    .then(function () {
      self.$uibModalInstance.close(true);
    }, function () {

      // Undo add
      if (self.mode === 'add') {
        self.mappings.shift();
      }

      self.vm.errorMessage = 'Unable to add Job Mapping, please try again, or try again later.';
    });
};

ImportExportJobMappingsModalController.prototype.editAction = function () {
  var self = this,
    originalMapping = Object.assign({}, self.mapping);

  // Edit
  Object.assign(this.mapping, this.vm.mapping);

  this.ImportJobsApiService.updateMappings(this.job.id, this.mappings)
    .then(function () {
      self.$uibModalInstance.close(true);
    }, function () {

      // Revert edit
      if (self.mode === 'edit') {
        Object.assign(self.mapping, originalMapping);
      }

      self.vm.errorMessage = 'Unable to edit Job Mapping, please try again, or try again later.';
    });
};

ImportExportJobMappingsModalController.prototype.deleteAction = function () {
  var self = this,
    index = self.mappings.indexOf(self.mapping);

  // Delete
  if (index !== -1) {
    self.mappings.splice(index, 1);
  }

  this.ImportJobsApiService.updateMappings(this.job.id, this.mappings)
    .then(function () {
      self.$uibModalInstance.close(true);
    }, function () {

      // Put deleted item back
      if (self.mode === 'delete') {
        self.mappings.splice(index, 0, self.mapping);
      }

      self.vm.errorMessage = 'Unable to delete Job Mapping, please try again, or try again later.';
    });
};

ImportExportJobMappingsModalController.prototype.getActionButtonLabel = function () {
  var label = 'Done';

  switch (this.mode) {
    case 'add':
      label = 'Add Mapping';
      break;
    case 'edit':
      label = 'Update Mapping';
      break;
    case 'delete':
      label = 'Delete Mapping';
      break;
  }

  return label;
};

ImportExportJobMappingsModalController.$inject = [
  '$uibModalInstance',
  'ImportJobsApiService',
  'ImportExportsApiService',
  'HelpersService',
  'JOB_TYPE',
  'job',
  'mode',
  'mappings',
  'mapping'
];
